import { format } from '@react-input/mask';
import { DEFAULT_MASK_CONFIG, type LiliCustomMask, LiliMask } from '../types/Mask';
import { PhoneNumberFormat } from 'google-libphonenumber';
import { PhoneUtil } from './phone';

export const formatWithMask = (value: string, mask: LiliCustomMask) => {
  return format(value, {
    ...DEFAULT_MASK_CONFIG,
    mask,
  });
};

export const formatEin = (ein: string) => formatWithMask(ein, LiliMask.EIN);
export const formatSSN = (ssn: string) => formatWithMask(ssn, LiliMask.SSN);
export const formatDate = (date: string) => formatWithMask(date, LiliMask.DATE);
export const formatPhone = (phone: string) => {
  try {
    if (!phone.startsWith('+')) phone = `+${phone}`;
    const phoneWithoutPrefix = getPhoneWithoutPrefix(phone);
    return formatWithMask(phoneWithoutPrefix, LiliMask.PHONE_US);
  } catch {
    return phone;
  }
};

export const getPhoneWithoutPrefix = (phone: string) => {
  try {
    const phoneInstance = PhoneUtil.parse(phone);
    return PhoneUtil.format(phoneInstance, PhoneNumberFormat.NATIONAL);
  } catch {
    return phone;
  }
};
